(function () {
  'use strict';

  function parseYouTubeMessage(data) {
    if (typeof data === 'object' && data !== null) return data;
    if (typeof data !== 'string') return null;
    try {
      return JSON.parse(data);
    } catch (error) {
      return null;
    }
  }

  function sendYouTubeMessage(frame, message) {
    if (!frame || !frame.contentWindow) return;
    frame.contentWindow.postMessage(JSON.stringify(message), 'https://www.youtube.com');
  }

  if (!window.__pdpStoryCommerceYouTubeListener) {
    window.__pdpStoryCommerceYouTubeListener = true;
    window.addEventListener('message', function (event) {
      if (event.origin !== 'https://www.youtube.com') return;
      var message = parseYouTubeMessage(event.data);
      if (!message) return;

      document.querySelectorAll('[data-pdp-story-trigger-youtube]').forEach(function (frame) {
        if (frame.contentWindow !== event.source) return;
        var player = frame.closest('[data-pdp-story-trigger-player]');
        if (!player) return;

        if (message.event === 'onReady') {
          sendYouTubeMessage(frame, { event: 'command', func: 'mute', args: [] });
          sendYouTubeMessage(frame, { event: 'command', func: 'playVideo', args: [] });
        }

        var playerState = null;
        if (message.event === 'onStateChange') playerState = message.info;
        if (message.event === 'infoDelivery' && message.info) playerState = message.info.playerState;
        if (playerState !== null && playerState !== undefined) {
          player.classList.toggle('is-playing', Number(playerState) === 1);
        }
      });
    });
  }

  function initPdpStoryCommerce(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    if (root.dataset.accent) {
      root.style.setProperty('--pdp-story-accent', root.dataset.accent);
    }
    if (root.dataset.triggerSizeDesktop) {
      root.style.setProperty('--pdp-story-trigger-size-desktop', root.dataset.triggerSizeDesktop + 'px');
    }
    if (root.dataset.triggerSizeMobile) {
      root.style.setProperty('--pdp-story-trigger-size-mobile', root.dataset.triggerSizeMobile + 'px');
    }

    var modal = root.querySelector('[data-pdp-story-modal]');
    var trigger = root.querySelector('[data-pdp-story-open]');
    var closeButtons = root.querySelectorAll('[data-pdp-story-close]');
    var shopButton = root.querySelector('[data-pdp-story-shop]');
    var actionShopButton = root.querySelector('[data-pdp-story-action-shop]');
    var shareButton = root.querySelector('[data-pdp-story-share]');
    var backButton = root.querySelector('[data-pdp-story-back]');
    var variantInput = root.querySelector('[data-pdp-story-variant]');
    var priceNode = root.querySelector('[data-pdp-story-price]');
    var stockNode = root.querySelector('[data-pdp-story-stock]');
    var addButton = root.querySelector('[data-pdp-story-add]');
    var buyButton = root.querySelector('[data-pdp-story-buy]');
    var checkoutButton = root.querySelector('[data-pdp-story-checkout]');
    var cartCountNodes = root.querySelectorAll('[data-pdp-story-cart-count]');
    var cartUnitNodes = root.querySelectorAll('[data-pdp-story-cart-unit]');
    var mediaStack = root.querySelector('[data-pdp-story-media-stack]');
    var triggerYouTubeFrames = root.querySelectorAll('[data-pdp-story-trigger-youtube]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-story-slide]'));
    var activeSlideIndex = 0;
    var lastFocus = null;
    var pendingStoryCartOpen = false;

    if (!modal || !trigger) return;

    triggerYouTubeFrames.forEach(function (frame) {
      var startListening = function () {
        sendYouTubeMessage(frame, { event: 'listening', id: frame.id });
      };
      frame.addEventListener('load', startListening);
      startListening();
    });

    if (mediaStack && slides.length > 1) {
      slides.sort(function (a, b) {
        return Number(a.dataset.sortOrder || 0) - Number(b.dataset.sortOrder || 0);
      });
      slides.forEach(function (slide, index) {
        slide.dataset.index = index;
        mediaStack.appendChild(slide);
      });
    }

    function showSlide(index) {
      if (!slides.length) return;
      activeSlideIndex = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === activeSlideIndex);
      });
      if (modal && !modal.hidden) primeActiveMedia();
    }

    function pauseStoryVideos() {
      modal.querySelectorAll('video').forEach(function (video) {
        video.pause();
      });

      modal.querySelectorAll('[data-pdp-story-youtube]').forEach(function (frame) {
        if (frame.getAttribute('src') !== 'about:blank') frame.setAttribute('src', 'about:blank');
      });
    }

    function primeActiveMedia() {
      var activeSlide = slides[activeSlideIndex];
      if (!activeSlide) return;

      slides.forEach(function (slide) {
        slide.querySelectorAll('video').forEach(function (video) {
          if (slide !== activeSlide) {
            video.pause();
            return;
          }

          video.muted = true;
          video.playsInline = true;
          if (video.readyState === 0) video.load();
          var playAttempt = video.play();
          if (playAttempt && typeof playAttempt.catch === 'function') playAttempt.catch(function () {});
        });

        slide.querySelectorAll('[data-pdp-story-youtube]').forEach(function (frame) {
          var source = frame.dataset.src;
          var shouldLoad = slide === activeSlide && !root.classList.contains('is-shopping');

          if (!shouldLoad) {
            if (frame.getAttribute('src') !== 'about:blank') frame.setAttribute('src', 'about:blank');
            return;
          }

          if (source && frame.getAttribute('src') !== source) frame.setAttribute('src', source);
        });
      });

      activeSlide.querySelectorAll('img.pdp-story-commerce__media').forEach(function (image) {
        image.loading = 'eager';
        image.decoding = 'async';
        if (typeof image.decode === 'function') image.decode().catch(function () {});
      });
    }

    function selectedVariant() {
      if (!variantInput) return null;
      if (variantInput.tagName === 'SELECT') {
        var option = variantInput.options[variantInput.selectedIndex];
        return {
          id: option.value,
          price: option.dataset.price,
          available: option.dataset.available === 'true'
        };
      }
      return {
        id: variantInput.value,
        price: variantInput.dataset.price,
        available: variantInput.dataset.available === 'true'
      };
    }

    function updateVariantState() {
      var variant = selectedVariant();
      if (!variant) return;
      if (priceNode) priceNode.textContent = variant.price;
      if (stockNode) {
        stockNode.textContent = variant.available ? stockNode.dataset.inStockLabel : stockNode.dataset.soldOutLabel;
      }
      if (addButton) addButton.disabled = !variant.available;
      if (buyButton) buyButton.disabled = !variant.available;
    }

    function openModal() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('pdp-story-commerce-lock');
      showSlide(0);
      var close = root.querySelector('[data-pdp-story-close]');
      if (close) close.focus({ preventScroll: true });
    }

    function closeModal() {
      pauseStoryVideos();
      modal.hidden = true;
      root.classList.remove('is-open', 'is-shopping');
      trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('pdp-story-commerce-lock');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    }

    function openPanel() {
      pauseStoryVideos();
      root.classList.add('is-shopping');
      if (backButton) backButton.focus({ preventScroll: true });
    }

    function shareProduct() {
      var shareData = {
        title: document.title,
        url: window.location.href.split('#')[0]
      };

      if (navigator.share) {
        navigator.share(shareData).catch(function () {});
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(shareData.url).catch(function () {});
      }
    }

    function closePanel() {
      root.classList.remove('is-shopping');
      primeActiveMedia();
      if (shopButton) shopButton.focus({ preventScroll: true });
    }

    function cartAddUrl() {
      return window.theme && window.theme.routes && window.theme.routes.cart_add_url ? window.theme.routes.cart_add_url : '/cart/add.js';
    }

    function cartUrl() {
      return window.theme && window.theme.routes && window.theme.routes.cart_url ? window.theme.routes.cart_url : '/cart';
    }

    function checkoutUrl() {
      return '/checkout';
    }

    function setLoading(button, loading) {
      if (!button) return;
      button.disabled = loading;
      button.classList.toggle('is-loading', loading);
    }

    function updateCartCount(count) {
      cartCountNodes.forEach(function (node) {
        node.textContent = count;
      });

      cartUnitNodes.forEach(function (node) {
        node.textContent = count === 1 ? node.dataset.singularLabel : node.dataset.pluralLabel;
      });

      document.querySelectorAll('[data-cart-count], cart-count').forEach(function (node) {
        node.textContent = count;
        node.setAttribute('data-cart-count', count);
      });
    }

    function refreshCartState() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          return cart;
        });
    }

    function refreshCartDrawer() {
      return fetch(cartUrl() + '?section_id=api-cart-items', { credentials: 'same-origin' })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var selectors = [
            '[data-items-holder]',
            '[data-cart-price-holder]',
            '[data-cart-errors]',
            '.drawer__items-title'
          ];

          selectors.forEach(function (selector) {
            var fresh = doc.querySelector(selector);
            var current = document.querySelector(selector);
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          });
        })
        .catch(function () {});
    }

    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) {
        window.location.href = cartUrl();
        return;
      }

      if (typeof drawer.openCartDrawer === 'function') {
        drawer.openCartDrawer(true);
      } else {
        drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));
      }
    }

    function addSelectedVariant(redirectToCheckout, loadingButton) {
      var variant = selectedVariant();
      if (!variant || !variant.available) return Promise.resolve();

      if (!redirectToCheckout) {
        pendingStoryCartOpen = true;
        if (window.accessibility) window.accessibility.lastElement = addButton;
        document.dispatchEvent(
          new CustomEvent('theme:cart:add', {
            detail: {
              button: addButton
            },
            bubbles: false
          })
        );
        return Promise.resolve();
      }

      var checkoutLoadingButton = loadingButton || buyButton;
      setLoading(checkoutLoadingButton, true);

      return fetch(cartAddUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: Number(variant.id),
          quantity: 1
        })
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (error) { throw error; });
          return response.json();
        })
        .then(function () {
          return Promise.all([refreshCartState(), refreshCartDrawer()]);
        })
        .then(function () {
          window.location.href = checkoutUrl();
        })
        .catch(function (error) {
          console.error('PDP story commerce add to cart failed:', error);
        })
        .finally(function () {
          setLoading(checkoutLoadingButton, false);
          updateVariantState();
        });
    }

    function goToCheckout() {
      setLoading(checkoutButton, true);

      return refreshCartState()
        .then(function (cart) {
          if (cart && cart.item_count > 0) {
            window.location.href = checkoutUrl();
            return;
          }

          return addSelectedVariant(true, checkoutButton);
        })
        .catch(function (error) {
          console.error('PDP story commerce checkout failed:', error);
          window.location.href = cartUrl();
        })
        .finally(function () {
          setLoading(checkoutButton, false);
        });
    }

    function handleStoryProductAdded() {
      if (!pendingStoryCartOpen) return;
      pendingStoryCartOpen = false;
      refreshCartState().catch(function () {});
      closeModal();
      openCartDrawer();
    }

    function handleStoryProductAddError(event) {
      if (!event.detail || event.detail.button !== addButton) return;
      pendingStoryCartOpen = false;
      updateVariantState();
    }

    trigger.addEventListener('click', openModal);
    shopButton && shopButton.addEventListener('click', openPanel);
    actionShopButton && actionShopButton.addEventListener('click', openPanel);
    shareButton && shareButton.addEventListener('click', shareProduct);
    backButton && backButton.addEventListener('click', closePanel);
    variantInput && variantInput.addEventListener('change', updateVariantState);
    addButton && addButton.addEventListener('click', function () { addSelectedVariant(false); });
    buyButton && buyButton.addEventListener('click', function () { addSelectedVariant(true, buyButton); });
    checkoutButton && checkoutButton.addEventListener('click', goToCheckout);
    mediaStack && mediaStack.addEventListener('click', function (event) {
      if (slides.length < 2 || event.target.closest('a, button, iframe')) return;
      showSlide(activeSlideIndex + 1);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.code === 'Escape' && !modal.hidden) closeModal();
    });
    document.addEventListener('theme:product:added:silent', handleStoryProductAdded);
    document.addEventListener('theme:product:added', handleStoryProductAdded);
    document.addEventListener('theme:product:add-error', handleStoryProductAddError);

    updateVariantState();
    refreshCartState().catch(function () {});
  }

  function initAll() {
    document.querySelectorAll('[data-pdp-story-commerce]').forEach(initPdpStoryCommerce);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
